<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="[]"
      :form-fields="formFields"
      pageName="doubaoAccount"
      :permission="permission"
      :buttons="[]"
      :searchs="searchs" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'

export default {
  name: 'DoubaoAccountList',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId', placeholder: '代理', type: 'select', selectUrl: '/agent/getAll', selectData: []
      }, {
        name: 'name', placeholder: '账号名称/备注', type: 'input'
      }, {
        name: 'enabled', placeholder: '启用状态', type: 'select', selectValue: [
          { key: 1, value: '启用' }, { key: 0, value: '停用' }
        ]
      }, {
        name: 'authMode', placeholder: '认证模式', type: 'select', selectValue: [
          { key: 'rpa', value: 'RPA' }, { key: 'api', value: 'API预留' }
        ]
      }],
      permission: { list: 'doubaoAccount:list' },
      url: { get: '/doubaoAccount/listByCondition' },
      formFields: { addTitle: '', updateTitle: '', model: [] },
      tableColumns: [{
        field: 'id', label: 'ID', show: true, width: '80'
      }, {
        field: 'accountName', label: '豆包账号', show: true
      }, {
        field: 'userId', label: '用户ID', show: true, width: '100'
      }, {
        field: 'agentId', label: '代理', selectUrl: '/agent/getAll', selectData: [], show: { type: 'select' }
      }, {
        field: 'authMode', label: '认证模式', show: true
      }, {
        field: 'enabled', label: '启用状态', show: { type: 'tag', tags: [
          { key: 1, value: '启用', type: 'success' }, { key: 0, value: '停用', type: 'info' }
        ] }
      }, {
        field: 'todayUsed', label: '今日用量', show: true
      }, {
        field: 'dailyLimit', label: '日配额', show: true
      }, {
        field: 'quotaDate', label: '额度日期', show: true
      }, {
        field: 'remark', label: '备注', show: true, detail: true
      }, {
        field: 'createTime', label: '创建时间', show: true
      }]
    }
  }
}
</script>
